// «Погледајте унутра»: праве стране Тома 1 (Gamma Estudio), WebP 1080×1350 у Recursos продавнице LIKOVNO SPREMNA.
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/42aa047b-4911-4503-8bd7-008f47dc72ca/1792847314355_lik-tom1-strana04-cb1ab542.webp',
    label: 'Том 1 · Страна 4',
    title: 'Фонд часова по програму',
    text: 'Колико часова има сваки разред и како их распоредити по месецима – на једној страни.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/42aa047b-4911-4503-8bd7-008f47dc72ca/1792847318197_lik-tom1-strana05-41d05e2e.webp',
    label: 'Том 1 · Страна 5',
    title: 'Годишњи план · 1. разред',
    text: 'Теме, број часова и техника за сваки месец, од септембра до јуна.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/42aa047b-4911-4503-8bd7-008f47dc72ca/1792847322123_lik-tom1-strana13-6b4aef6c.webp',
    label: 'Том 1 · Страна 13',
    title: 'Структура часа од 45 минута',
    text: 'Мотивација, показивање технике, самостални рад, мини изложба и распремање – минут по минут.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/42aa047b-4911-4503-8bd7-008f47dc72ca/1792847326053_lik-tom1-strana15-0b9f18d6.webp',
    label: 'Том 1 · Страна 15',
    title: 'Час 1 · лист у 3 нивоа',
    text: 'Исти задатак за основни, средњи и напредни ниво, са упутством за наставника.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/42aa047b-4911-4503-8bd7-008f47dc72ca/1792847330060_lik-tom1-strana16-bc4541ec.webp',
    label: 'Том 1 · Страна 16',
    title: 'Час 2 · 2. разред',
    text: 'Циљ, материјал и ток часа минут по минут – спремно да уђете у учионицу.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/42aa047b-4911-4503-8bd7-008f47dc72ca/1792847334093_lik-tom1-strana24-0ccd9e70.webp',
    label: 'Том 1 · Страна 24',
    title: 'Час за старије разреде',
    text: 'Задатак, материјал и вредновање за више разреде, у истој јасној структури.'
  }
];
